import { useEffect, useMemo, useRef, useState } from "react";
import Aside from "../../components/Aside";
import Footer from "../../components/Footer";
import HandleNoData from "../../components/HandleNoData";
import Header from "../../components/Header";
import EmptyState from "../../components/EmptyState";
import moment from "moment";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CampaignService } from "../../services/campaignService";
import ChatMessages from "../../components/ChatMessages";


declare const bootstrap: any;

export default function CampaignDetailPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { campaign } = location.state as { campaign: any };

  const modalRef = useRef<HTMLDivElement>(null);
  

  const [showDetail, setShowDetail] = useState({
    show: false,
    data: null
  })
  const [rows, setRows] = useState([]);
  const [campaignInfo, setCampaignInfo] = useState<any>({});
  const [modal, setModal] = useState<any>(null);

  const header = useMemo(
    () => campaignInfo?.whatsapp?.template?.components?.find((c) => c.type === "HEADER"),
    [campaignInfo]
  );
  const body = useMemo(
    () => campaignInfo?.whatsapp?.template?.components?.find((c) => c.type === "BODY"),
    [campaignInfo]
  );
  const footer = useMemo(
    () => campaignInfo?.whatsapp?.template?.components?.find((c) => c.type === "FOOTER"),
    [campaignInfo]
  );
  const buttons = useMemo(
    () => campaignInfo?.whatsapp?.template?.components?.find((c) => c.type === "BUTTONS"),
    [campaignInfo]
  );


  const totalFailed = useMemo(() => {
    return rows.filter( m => m.status === 'failed' || m.status === 'undelivered').length;
  }, [rows]);
  
  // const totalSent = useMemo(() => {
  //   return rows.filter( m => m.status === 'sent' || m.status === 'delivered').length;
  // }, [rows]);
  
  const totalDelivered = useMemo(() => {
    return rows.filter( m => m.status === 'received' || m.status === 'read').length;
  }, [rows]);

  const getStatusMessage = (status: string) => {
    switch (status) {
      case 'sent':        
        return 'Enviado'
      case 'delivered':        
        return 'Entregado'
      case 'undelivered':        
        return 'No entregado'
      case 'read':        
        return 'Leído'
      case 'failed':        
        return 'Fallido'
      case 'received':        
        return 'Recibido'
    
      default:
        return status;
    }
  }

  const getStats = async () => {
    const response = await CampaignService.getStats(campaign._id);
    setRows(response.messages);
    setCampaignInfo(response.campaign);
  };

  const showModal = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    modal.show();
  };

  useEffect(() => {
    if (modalRef.current) {
      const modalInstance = new bootstrap.Modal(modalRef.current, {});
      setModal(modalInstance);
    }
  }, [modalRef]);

  useEffect(() => {
    getStats();
  }, []);

  return (
    <>
      <Header>
        <div>
          <h4>Detalle de campaña {campaign.name}</h4>
          {/* <p>Administra y crea nuevas campañas</p> */}
        </div>
      </Header>

      <Aside />

      <main role="main" className="main">
        <div className="content container px-5">
          <div className="col-12 m-b-24">
            <button
              type="button"
              className="btn btn-link text-dark text-decoration-underline px-0"
              onClick={() => navigate(-1)}
            >
              <i className="bi bi-arrow-left me-2"></i> Regresar
            </button>
          </div>

          <div className="col-12 m-b-24">
            <div className="card ">
              <div className="card-body d-flex">
                <div className="mx-4  flex-grow-1 ">
                  <h4 className="">{campaignInfo?.name}</h4>
                  <p className="nowrap">
                    Fecha y hora de envío:{" "}
                    {moment(campaignInfo?.sent_at).format("DD/MM/YY HH:mm")}
                  </p>
                  <p className="nowrap">
                    Segmentación:{" "}
                    {campaignInfo?.segmentations
                      ?.map((segment: any) => segment.title)
                      .join(", ")}{" "}
                  </p>
                  <p className="nowrap">
                    Material:{" "}
                    <Link
                      to={`/materials/detail/${campaignInfo?.content_repository?._id}`}
                      target="_blank"
                      className="text-decoration-underline"
                    >
                      {campaignInfo?.content_repository?.name} <i className="bi-box-arrow-up-right ms-2"></i>
                    </Link>
                  </p>
                  <p className="nowrap">
                    Template:{" "}
                    <Link
                      to="#"
                      onClick={showModal}
                      className="text-decoration-underline"
                    >
                      {campaignInfo?.whatsapp?.template?.name}
                    </Link>
                    
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 m-b-24">
            <div className="card ">
              <div className="card-body d-flex">
                <div className="mx-4 text-center flex-grow-1 ">
                  <h3 className="text-center">{rows.length}</h3>
                  <p className="nowrap">Total mensajes </p>
                </div>
                {/* <div className='border-lg-end'></div>
                      <div className='mx-4 text-center flex-grow-1 '>
                          <h3 className="text-center">{totalSent}</h3>
                          <p className='nowrap'>Total enviados </p>
                      </div> */}
                <div className="border-lg-end"></div>
                <div className="mx-4 text-center flex-grow-1 ">
                  <h3 className="text-center">{totalDelivered}</h3>
                  <p className="nowrap">Total entregados </p>
                </div>
                <div className="border-lg-end"></div>
                <div className="mx-4 text-center flex-grow-1 ">
                  <h3 className="text-center">{totalFailed}</h3>
                  <p className="nowrap">Total fallidos </p>
                </div>
              </div>
            </div>
          </div>

          <HandleNoData condition={rows.length} emptyComponent={<EmptyState />}>
            <table className="card-table table">
              <thead>
                <tr>
                  <th scope="col">NOMBRE y Correo electrónico</th>
                  <th scope="col">Opt-In</th>
                  <th scope="col">Teléfono</th>
                  <th scope="col">Segmentación</th>
                  <th scope="col">Fecha de envio</th>
                  <th scope="col">Estatus mensaje</th>
                  <th scope="col">Última actualización</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((message: any) => (
                  <tr key={message._id}>
                    <td>
                      <div className="d-flex ">
                        <span className="avatar avatar-sm avatar-primary avatar-circle">
                          <img
                            className="avatar-img"
                            src={message.chat.contact.avatar}
                            alt={
                              message.chat.contact.first_name +
                              " " +
                              message.chat.contact.last_name
                            }
                          />
                        </span>
                        <div className="m-l-16">
                          <p className="fw-semibold text-dark">
                            {message.chat.contact.first_name}{" "}
                            {message.chat.contact.last_name}
                          </p>
                          {message.chat.contact.email ? (
                            <p>{message.chat.contact.email}</p>
                          ) : (
                            <p>Sin correo</p>
                          )}
                        </div>
                      </div>
                    </td>
                    <td>
                      {message.chat.contact.opt_in_accepted && (
                        <span className="badge bg-soft-primary text-primary ">
                          Otorgado
                        </span>
                      )}
                      {message.chat.contact.opt_in_accepted === false && (
                        <span className="badge bg-soft-danger text-dark ">
                          No otorgado
                        </span>
                      )}
                      {message.chat.contact.opt_in_accepted === undefined && (
                        <span className="badge bg-soft-warning text-dark ">
                          No solicitado
                        </span>
                      )}
                    </td>

                    <td>{message.chat.number}</td>
                    <td>
                      {message.chat.contact.segmentations
                        .map((segment: any) => segment.title)
                        .join(", ")}
                    </td>
                    <td>
                      {moment(message.created_at).format("DD/MM/YY HH:mm")}
                    </td>
                    <td>{getStatusMessage(message.status)}</td>
                    <td>
                      {moment(message.updated_at).format("DD/MM/YY HH:mm")}
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-outline-edit btn-icon m-l-8"
                        onClick={() =>
                          setShowDetail({ show: true, data: message.chat })
                        }
                      >
                        <i className="bi bi-eye-fill"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </HandleNoData>
        </div>

        <Footer />
      </main>

      <ChatMessages
        chat={showDetail.data}
        show={showDetail.show}
        onRequestClose={() => setShowDetail({ show: false, data: null })}
      />

      <div
        className="modal fade"
        ref={modalRef}
        tabIndex={-1}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Vista previa</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row ">
                <div className="col">
                  <div className="template-preview">
                    <div className="template-preview-container mb-1">
                      {header && (
                        <div className="template-preview-header mb-2">
                          <p className="text-dark fw-semibold">{header.text}</p>
                        </div>
                      )}
                      <div className="template-preview-body">
                        <p
                          dangerouslySetInnerHTML={{
                            __html: body?.text
                              ? parserStringToHTML(body?.text)
                              : "",
                          }}
                        ></p>
                      </div>

                      {footer && (
                        <div className="template-preview-footer mt-2">
                          {" "}
                          <p className="small">{footer.text}</p>{" "}
                        </div>
                      )}
                    </div>

                    {buttons?.buttons?.map((btn, i) => (
                      <div className="template-preview-btn" key={i}>
                        <p>{btn.text}</p>
                      </div>
                    ))}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


export const EscapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export function parserStringToHTML(input: string): string {
  return input ? input.replace(/\n/g, '<br />'): '';
}
